import { render, staticRenderFns } from "./Orientacoes.vue?vue&type=template&id=a17cdbf4&"
import script from "./Orientacoes.vue?vue&type=script&lang=js&"
export * from "./Orientacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports